import { render, staticRenderFns } from "./DownloadCrumbLinks.vue?vue&type=template&id=61397a09&scoped=true"
import script from "./DownloadCrumbLinks.vue?vue&type=script&lang=js"
export * from "./DownloadCrumbLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61397a09",
  null
  
)

export default component.exports